import { CommitmentEventCommitments as CommitmentEventCommitmentsComponent } from '../../../components/Commitment/CommitmentEvents/CommitmentEventCommitments';

export function CommitmentEventCommitments() {
  return <CommitmentEventCommitmentsComponent />;
}
